// 路由信息，纯JS对象，方便读取路由信息
import Home from './views/Home.vue';
import PersonInfo from './views/PersonInfo.vue';
import Result from './views/Result.vue';
import Detail from './views/Detail.vue';
import Record from './views/Record.vue';
import { url } from '@tencent/ppd-base-libs';
import { ERouterName } from './config/constants';

export default {
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (url.getUrlParam('listid')) {
          next({ path: '/result' });
          return;
        }
        next();
      },
      cname: '慈善首页',
    },
    {
      path: '/person',
      name: 'person',
      component: PersonInfo,
      cname: '捐赠人资料页',
    },
    {
      path: '/result',
      name: 'result',
      component: Result,
      cname: '捐赠详情页',
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail,
      cname: '慈善项目详情页',
    },
    {
      path: '/record',
      name: 'record',
      component: Record,
      cname: '捐赠记录页',
    },
    {
      path: `/${ERouterName.outsideWx}`,
      name: ERouterName.outsideWx,
      component: () => import('./views/outside-wx.vue'),
      cname: '端外打开',
    },
  ],
};
